import { Loader } from 'component-library';
import { ThemeProvider } from 'deprecated-component-library';
import { Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, Outlet, Route } from 'react-router-dom';

import { tokenStorage } from '@/config/tokenStorage';
import { CustomUserContextProvider } from '@/lib/auth';
import { CustomLandlerAuthenticationProvider } from '@/lib/auth/CustomLandlerAuthenticationProvider';

import { ErrorBoundary } from './components/error-boundary/error-boundary';
import { FallbackError } from './components/fallback-error/fallback-error';
import { PlotGroupProvider } from './components/PlotGroups/PlotGroupsContextProvider';
import { FilterProvider } from './pages/shared/components/FilterContext';
import { pageRoutes } from './routing/PageRoutes';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <CustomLandlerAuthenticationProvider tokenStorage={tokenStorage}>
          <CustomUserContextProvider>
            <FilterProvider>
              <PlotGroupProvider>
                <ThemeProvider>
                  <ErrorBoundary fallback={<FallbackError />}>
                    <Suspense fallback={<Loader />}>
                      <Outlet />
                    </Suspense>
                  </ErrorBoundary>
                </ThemeProvider>
              </PlotGroupProvider>
            </FilterProvider>
          </CustomUserContextProvider>
        </CustomLandlerAuthenticationProvider>
      }
    >
      {pageRoutes}
    </Route>,
  ),
);
